import { React, useState, Image } from "react";
import Header from "../../Components/Header";
import SideBar from "../../Components/SideBar";
import { BallerzToken, BallerzRedirect } from "../../Client/Ballerz.js";
import { useGetRequest } from "../../Client/index.js";
import SkillCard from "../../Components/SkillCard";
import MobileDropdown from "../../Components/MobileDropdown";
import MobileFooter from "../../Components/MobileFooter";
import { useLocation } from "react-router-dom";
import Game from "./Game.js";

export default function Leaderboard() {
  let ballerzToken = BallerzToken();

  const location = useLocation();
  const bookingReference = location.state?.bookingReference;

  if (!ballerzToken) {
    BallerzRedirect();
  }

  const { status, data } = useGetRequest("skillzone/leaderboard", {});

  if (status === "fetched") {
    return (
      <div className="min-h-screen flex flex-col bg-[#070d27] text-white">
        <Header
          title={"skillzone"}
          users={data?.users}
          bookingReference={data?.bookingReference}
          username={data?.username}
        />


        <div className="flex flex-1">
          <SideBar />

          <main className="flex-1 p-4 sm:p-6">
            <div className="flex flex-col gap-4">
              <div className="block sm:hidden">
                <MobileDropdown />
              </div>

              {data.output?.length === 0 && (
                <a
                  href="https://ballerz.co.uk/book-now/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={require("../../Assets/Images/NoSkillzone.png")}
                    alt="No results"
                    draggable={false}
                    className="w-[50%] h-auto mx-auto"
                  />
                </a>
              )}

              {data?.output?.map((game, index) => (
              <Game
                key={index}
                game={game}
              />
              ))}
            </div>

            <div className="block sm:hidden">
              <MobileFooter />
            </div>
          </main>
        </div>
      </div>
    );
  }
}
